import { nanoid } from 'nanoid';

/**
 * Generate a unique ID using nanoid
 */
export default function generateId(): string {
  return nanoid();
}
